import Actions from './actions';
import AnswerUtil from './answer-util';
import BaseStore from './base-store';

import Immutable from 'immutable';
import Superagent from 'superagent';

/**
 * (Immutable) Data Model for the AnswerStore.
 */
export const AnswerStoreState = new Immutable.Record({
  // Controller Response for a question.
  controllerResponse: undefined,
  // HTTP status of controller response.
  controllerResponseStatus: undefined,
  // Controller returned error for a question.
  controllerError: false,
});

/**
 * The minimum time it should take to answer a question.  After adding a solver response cache
 * things are too "quick" such that the user doesn't get the impression that it's a live demo.
 * Accordingly, ensure there's some latency when asking a question.
 */
const MIN_ASK_TIME_MS = 1000;

/**
 * The Store that returns the controller response for a given question.
 * Processes the action REQUEST_ANSWER.
 * Makes a GET request of the question to the demo server, which forwards it to the controller,
 * and emits response upon receiving.
 */
export default class AnswerStore extends BaseStore {
  constructor(dispatcher) {
    super();

    this.state = new AnswerStoreState();

    dispatcher.register((payload) => {
      switch (payload.actionType) {
        case Actions.REQUEST_ANSWER: {
          if (!payload.id) {
              // Missing id means we should render an error
              this.state = this.state.withMutations(state => {
                state.set('controllerError', true);
              });
              this.emitChange(this.state);
              break;
          }

          var startTime = Date.now();
          Superagent.get('/assets/predictions/' + payload.id + '.json').end((err, response) => {
            if (!err && response) {
              // Enclose in try block to catch possible JSON parse
              // exception.
              try {
                this.state = this.state.withMutations(state => {
                  const controllerResponse = JSON.parse(response.text);
                  const updatedControllerResponse = AnswerUtil.getControllerResponseWithNormalizedScores(controllerResponse);
                  state.set('controllerResponse', updatedControllerResponse);
                });
              } catch (e) {
                console.log("Could not parse JSON response for GET request to controller");
                this.state = this.state.withMutations(state => {
                  state.set('controllerError', true);
                });
              }

              this.state = this.state.withMutations(state => {
                state.set('controllerResponseStatus', response.status);
              });
            }
            else {
              this.state = this.state.withMutations(state => {
                state.set('controllerError', true);
              });
            }
            var duration = Date.now() - startTime;
            var remaining = Math.max(MIN_ASK_TIME_MS + (500 * Math.random()) - duration, 0); // Add some small "random" variance to timing
            if (remaining > 0) {
              setTimeout(this.emitChange.bind(this, this.state), remaining);
            } else {
               this.emitChange(this.state);
            }
          });
          break;
        }
      }
    });
  }
}
